import PropTypes from 'prop-types';
import React, { Children } from 'react';
import clsx from 'clsx';

/**
 *  The BoxGrid component takes children and wraps them in a grid based on columnCount
 *  and spans the last (or only) item across the entire width if it is orphaned
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function BoxGrid(_ref) {
  let {
    breakpoint = 'sm',
    children,
    className,
    columnCount = 2,
    dataCmp = 'boxGrid',
    ...rest
  } = _ref;
  const boxes = Children.toArray(children);

  // If we have an uneven number of boxes, add grid-spanning styling
  if (boxes.length % columnCount === 1) {
    boxes.push(
    /*#__PURE__*/
    // Cloned to preserve its ref
    React.cloneElement(boxes.pop(), {
      style: {
        gridColumnStart: 1,
        gridColumnEnd: -1
      }
    }));
  }
  const breakpointClass = breakpoint === 'xs' ? `box-grid-col-${columnCount}` : `box-grid-col-${breakpoint}-${columnCount}`;
  return !!boxes.length && /*#__PURE__*/_jsx("div", {
    className: clsx('box-grid', breakpointClass, className),
    "data-cmp": dataCmp,
    ...rest,
    children: boxes.map(box => box)
  });
}
export default BoxGrid;